<template>
  <div>
    <PageHeader title="Population Health" subtitle="Population assessment and data integration">
      <template #bottom>
        <Page_Tabs :tabs="tabOptions" class="px-6 pt-4" no-border />
      </template>
    </PageHeader>
    <div class="p-6">
      <div class="bg-white rounded border border-gray-200">
        <PHM_PopulationAssessment v-if="activeTab === 'population-assessment'" />
        <PHM_DataIntegration v-else-if="activeTab === 'data-integration'" />
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from '@/components/widgetcomponents/library/PageHeader.vue';
import Page_Tabs from '@/components/widgetcomponents/Page_Tabs.vue';
import PHM_PopulationAssessment from '@/components/PHM/PHM_PopulationAssessment.vue';
import PHM_DataIntegration from '@/components/PHM/PHM_DataIntegration.vue';

export default {
  name: 'PHM_Dashboard',
  components: {
    PageHeader,
    Page_Tabs,
    PHM_PopulationAssessment,
    PHM_DataIntegration
  },
  data() {
    return {
      tabOptions: [
        { label: 'Population Assessment', icon: ['fas', 'users'], to: '/phm/population-assessment' },
        { label: 'Data Integration', icon: ['fas', 'table'], to: '/phm/data-integration' }
      ]
    }
  },
  computed: {
    activeTab() {
      if (this.$route.path.includes('data-integration')) return 'data-integration';
      return 'population-assessment';
    }
  }
};
</script>
